import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { mappingResultError, Result, UseCase } from '@digibricks/core';
export var UPDATE_QUESTION_USE_CASE = 'UPDATE_QUESTION_USE_CASE';
export var UpdateQuestionUseCase = /*#__PURE__*/function (_UseCase) {
  _inherits(UpdateQuestionUseCase, _UseCase);

  var _super = _createSuper(UpdateQuestionUseCase);

  function UpdateQuestionUseCase() {
    _classCallCheck(this, UpdateQuestionUseCase);

    return _super.apply(this, arguments);
  }

  _createClass(UpdateQuestionUseCase, [{
    key: "buildUseCase",
    value: function () {
      var _buildUseCase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(useCaseInput) {
        var updatedQuestionOrError, updatedQuestion;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                updatedQuestionOrError = this.updateQuestion(useCaseInput);

                if (!updatedQuestionOrError.isFailure) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", mappingResultError(updatedQuestionOrError));

              case 3:
                updatedQuestion = updatedQuestionOrError.getValue();
                return _context.abrupt("return", Result.ok(updatedQuestion));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function buildUseCase(_x) {
        return _buildUseCase.apply(this, arguments);
      }

      return buildUseCase;
    }()
  }, {
    key: "updateQuestion",
    value: function updateQuestion(input) {
      var updatingPayload = input.data,
          currentQuestion = input.currentQuestion;
      var question = currentQuestion;
      var description = updatingPayload.description,
          score = updatingPayload.score,
          files = updatingPayload.files,
          explanation = updatingPayload.explanation,
          audioFile = updatingPayload.audioFile,
          sectionId = updatingPayload.sectionId;
      var updatedResults = [];

      if (description) {
        updatedResults.push(question.updateDescription(description));
        var imgTagRegex = /<img[^>]*>/g;
        var imagesInDescription = question.description.match(imgTagRegex);
        var urls = imagesInDescription === null || imagesInDescription === void 0 ? void 0 : imagesInDescription.map(function (i) {
          // eslint-disable-next-line no-useless-escape
          var regex = /(?<=src=\")([^\"]+)/;
          var match = regex.exec(i);

          if (match) {
            return match[1];
          }
        });

        if (urls) {
          var foundFiles = question.files.filter(function (f) {
            return urls.find(function (u) {
              return u === f.url;
            });
          });
          question.updateFiles(foundFiles);
        } else {
          question.updateFiles([]);
        }
      }

      if (score) {
        updatedResults.push(question.updateScore(score));
      }

      if (explanation) {
        updatedResults.push(question.updateExplanation(explanation));
      }

      if (files) {
        updatedResults.push(question.updateFiles(files));
      }

      if (audioFile) {
        updatedResults.push(question.updateAudioFile(audioFile));
      }

      if (sectionId) {
        updatedResults.push(question.updateSectionId(sectionId));
      }

      var updatedQuestionResult = this.updateExtendedQuestion(input);

      if (updatedQuestionResult.isFailure) {
        return mappingResultError(updatedQuestionResult);
      }

      var resultCombine = Result.combine(updatedResults);

      if (resultCombine.isFailure) {
        return mappingResultError(resultCombine);
      }

      return Result.ok(question);
    }
  }, {
    key: "updateExtendedQuestion",
    value: function updateExtendedQuestion(input) {
      return Result.ok(input.currentQuestion.clone());
    }
  }]);

  return UpdateQuestionUseCase;
}(UseCase);